import { render, staticRenderFns } from "./PlacementsStatusCellStep.vue?vue&type=template&id=34822694"
import script from "./PlacementsStatusCellStep.vue?vue&type=script&lang=js"
export * from "./PlacementsStatusCellStep.vue?vue&type=script&lang=js"
import style0 from "./PlacementsStatusCellStep.vue?vue&type=style&index=0&id=34822694&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports